import { Box, Tooltip } from '@mui/material';
import { LOW_CONFIDENCE } from '../../../lib/packingListValidation';

/**
 * 파서가 자신 없어 한 셀의 좌하단에 점을 찍어 원문과 대조하라고 알린다. 손으로 고친 셀은 표시하지 않는다.
 * 신뢰도 80% 미만이면 주황 점, 후보가 둘이어서 하나를 고른 칸(note, 예: 두 번째 G.W 열의 값)은 파란 점이고 툴팁에 버린 값을 적는다.
 */
export default function ConfidenceMark({ confidence, field, edited, note }) {
    const low = typeof confidence === 'number' && confidence < LOW_CONFIDENCE;
    if (edited || (!low && !note)) return null;
    const title = [low ? `Extraction confidence ${Math.round(confidence * 100)}% (${field}). Please verify against the document.` : null, note ? `Another candidate in the document: ${note}` : null].filter(Boolean).join(' ');
    return (
        <Tooltip title={title} placement="top" arrow>
            <Box sx={{ position: 'absolute', left: 3, bottom: 3, width: 7, height: 7, borderRadius: '50%', bgcolor: low ? 'warning.main' : 'info.main', zIndex: 1 }} />
        </Tooltip>
    );
}
